'use client';

import { Study } from '@/lib/study';
import { T } from '@/lib/tokens';
import { Nav } from '../StepShell';
import { StepHead, StepWrap } from '../StepShell';
import { Textarea } from '../Textarea';

type Props = {
  data: Study;
  setData: (d: Study) => void;
  onNext: () => void;
};

export function Step1Goal({ data, setData, onNext }: Props) {
  return (
    <StepWrap>
      <StepHead
        label="Step 1 — Study Goal"
        title="What is your study about?"
        subtitle="Describe the overall research goal in a sentence or two. This helps the AI understand the topic of the interview."
      />
      <Textarea
        value={data.goal}
        onChange={(v) => setData({ ...data, goal: v })}
        rows={4}
        placeholder="e.g. Understand how people use AI for companionship"
      />
      <div
        style={{
          background: T.terraLight,
          border: `1px solid ${T.terraMid}`,
          borderRadius: 10,
          padding: '14px 18px',
          fontSize: 14,
          color: T.espressoMid,
          lineHeight: 1.6,
        }}
      >
        <strong style={{ color: T.espresso }}>Tip:</strong>{' '}
        Be clear enough that the AI understands the scope of your study. You
        don&apos;t need to list questions here — just describe what you&apos;re
        trying to explore.
      </div>
      <Nav onNext={onNext} nextDisabled={!data.goal.trim()} />
    </StepWrap>
  );
}
